import { PureComponent } from "react";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import FaqIcon from "../../../svgs/faq.svg";
import TopicIcon from "../../../svgs/topic.svg";
import UpRightIcon from "../../../svgs/up-right.svg";
import YouTubeSquare from "../../../svgs/youtube-square.svg";
import "./zendesk-right-panel.scss";

class ZendeskRightPanel extends PureComponent {
  private onClickVideoCourses = () => {
    window.open("https://academy.kuika.com/en/courses", "_blank");
  };

  private onClickTopics = () => {
    window.open("https://academy.kuika.com", "_blank");
  };

  private onClickFaq = () => {
    window.open("https://www.kuika.com/en/platform/faq", "_blank");
  };

  render() {
    const isMainAI = KMainFunctions.isMainAI();
    if (isMainAI) return null;
    return (
      <div className="zendesk-right-panel">
        <div className="kuika_right-panel__header">
          <span className="kuika_right-panel__header__title">Explore documentation</span>
        </div>
        <button className="zendesk-right-panel--item" onClick={this.onClickVideoCourses}>
          <div className="zendesk-right-panel--item-header">
            <YouTubeSquare />
            <div className="zendesk-right-panel--item-upright-button">
              <UpRightIcon />
            </div>
          </div>
          <div className="zendesk-right-panel--item-title">Video Courses</div>
          <div className="zendesk-right-panel--item-description">
            Learn to use the Kuika platform with video courses with sample applications.
          </div>
        </button>
        <button className="zendesk-right-panel--item" onClick={this.onClickTopics}>
          <div className="zendesk-right-panel--item-header">
            <TopicIcon />
            <div className="zendesk-right-panel--item-upright-button">
              <UpRightIcon />
            </div>
          </div>
          <div className="zendesk-right-panel--item-title">Topics</div>
          <div className="zendesk-right-panel--item-description">
            Learn Terminology, Elements, Actions, UI/UX Design, SQL and more.
          </div>
        </button>
        <button className="zendesk-right-panel--item" onClick={this.onClickFaq}>
          <div className="zendesk-right-panel--item-header">
            <FaqIcon />
            <div className="zendesk-right-panel--item-upright-button">
              <UpRightIcon />
            </div>
          </div>
          <div className="zendesk-right-panel--item-title">FAQ</div>
          <div className="zendesk-right-panel--item-description">
            Check out the most frequently asked questions. Discover the platform.
          </div>
        </button>
      </div>
    );
  }
}

export default ZendeskRightPanel;
